const VALID_PHONE_NUMBERS = [10, 11]

export const extendedRules = {
  phone1: {
    params: ['phone2', 'phone3'],
    validate(val, { phone2 = '', phone3 = '' }) {
      const phoneNumber = val + phone2 + phone3
      return VALID_PHONE_NUMBERS.includes(phoneNumber.length)
    },
    message: '電話番号の形式が正しくありません。',
  },
  phone2: {
    params: ['phone1', 'phone3'],
    validate(val, { phone1 = '', phone3 = '' }) {
      const phoneNumber = val + phone1 + phone3
      return VALID_PHONE_NUMBERS.includes(phoneNumber.length)
    },
    message: '電話番号の形式が正しくありません。',
  },
  phone3: {
    params: ['phone1', 'phone2'],
    validate(val, { phone1 = '', phone2 = '' }) {
      const phoneNumber = val + phone1 + phone2
      return VALID_PHONE_NUMBERS.includes(phoneNumber.length)
    },
    message: '電話番号の形式が正しくありません。',
  },
  kana: {
    validate(val) {
      const rule = new RegExp('^[ァ-ヶー]+$')
      return rule.test(val)
    },
    message: '{_field_}はカタカナで入力してください。',
  },
  email_address: {
    validate(val) {
      const rule = new RegExp(
        '^(([^<>()[\\]\\.,;:\\s@"]+(\\.[^<>()[\\]\\.,;:\\s@"]+)*)|(".+")).?@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$'
      )
      return rule.test(val)
    },
    message: '{_field_}は有効なメールアドレスではありません',
  },
  number_before: {
    params: ['valBefore'],
    validate(val, { valBefore = '' }) {
      if (valBefore == '' || valBefore == null || val == '' || val == null) return true

      return parseInt(val) <= parseInt(valBefore)
    },
    message: '{_field_}は無効です。',
  },
  number_after: {
    params: ['valAfter'],
    validate(val, { valAfter = '' }) {
      if (valAfter == '' || valAfter == null || val == '' || val == null) return true

      return parseInt(val) >= parseInt(valAfter)
    },
    message: '{_field_}は無効です。',
  },
  max_bytes: {
    validate(val, [maxBytes]) {
      if (val == '' || val == null || maxBytes == '' || maxBytes == null) return true

      let valBytes = new Blob([val]).size

      return valBytes <= maxBytes
    },
    message: '{_field_}は無効です。',
  },
  uniqueNum: {
    validate(val, items) {
      if (val == '' || val == null) {
        return true
      }
      const dataFilters = items.filter(ele => ele.index !== ele.keyChange && ele.val)
      const check = dataFilters.findIndex(ele => +ele.val === +val)

      return !(check !== -1)
    },
    message: '番号は既に存在します。',
  },
  kanji: {
    validate(val) {
      const rule = new RegExp('^[一-龥ぁ-んァ-ン]+$')
      return rule.test(val)
    },
    message: '{_field_}は漢字で入力してください。',
  },
  float: {
    validate(val) {
      const rule = new RegExp('^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$')
      return rule.test(val)
    },
    message: '{_field_}は無効です。',
  },
  max_size: {
    params: [{ name: 'max' }],
    validate(files, { max }) {
      let file

      if (Array.isArray(files)) {
        file = files[0]
      } else {
        file = files
      }

      if (typeof max === 'string') {
        max = parseInt(max)
      }

      return file.size <= max * 1024 * 1024
    },
    message: '{_field_}は{max}MB以下でなければなりません',
  },
  positive: {
    validate(val) {
      const reg = new RegExp('^[0-9]+$')
      if (!reg.test(val)) {
        return false
      }

      return val >= 0
    },
    message(fileldName, field) {
      const numberReg = new RegExp('^[-]?[0-9]+([.][0-9]+)?$')
      if (!numberReg.test(field['_value_'])) {
        return `${fileldName}は数字のみ使用できます`
      }

      const realNumberReg = new RegExp('^[-]?[0-9]+[.][0-9]+$')
      if (realNumberReg.test(field['_value_'])) {
        return `${fileldName}は整数のみ使用できます`
      }

      return `${fileldName}は正の値のみ使用できます`
    },
  },
}
